type ToolCardProps = {
  title: string
  description: string
  icon: string
  image: string
  linkUrl?: string
  mediaClassName?: string
}

export const toolCardsData: ToolCardProps[] = [
  {
    title: 'Dashboards',
    description: 'Custom visualizations, drill-downs, filters, and more.',
    icon: '/images/pages/home/tool-cards/icons/dashboards-icon.webp',
    image: '/images/pages/home/tool-cards/screens/dashboards-screen.webp',
  },
  {
    title: 'Spreadsheets',
    description:
      'Familiar formulas, forecasting, and modeling on top of live, governed data.',
    icon: '/images/pages/home/tool-cards/icons/spreadsheets-icon.webp',
    image: '/images/pages/home/tool-cards/screens/spreadsheets-screen.webp',
    linkUrl: '/spreadsheets',
    mediaClassName: 'feature-card-media--spreadsheets',
  },
  {
    title: 'Point-and-click',
    description: 'An intuitive field picker and chart editor anyone can use.',
    icon: '/images/pages/home/tool-cards/icons/point-and-click-icon.webp',
    image: '/images/pages/home/tool-cards/screens/point-n-click-screen.webp',
  },
  {
    title: 'SQL',
    description: 'Raw SQL in an IDE with intelligent autocomplete.',
    icon: '/images/pages/home/tool-cards/icons/sql-icon.webp',
    image: '/images/pages/home/tool-cards/screens/sql-screen.webp',
  },
]
